import { useCallback, useState } from "react";

import { ConditionOperationUpdate, FilterConditionOperation } from "../types";

export const useFilterConditionOperator = (): [FilterConditionOperation, ConditionOperationUpdate] => {
  const [conditionOperation, setConditionOperation] = useState(FilterConditionOperation.AND);

  const toggleConditionOperation = useCallback(() => {
    const newConditionOperation =
      conditionOperation === FilterConditionOperation.AND ? FilterConditionOperation.OR : FilterConditionOperation.AND;

    setConditionOperation(newConditionOperation);
  }, [conditionOperation, setConditionOperation]);

  return [conditionOperation, { toggleConditionOperation, setConditionOperation }];
};
